














import { computed, defineComponent, ref } from "@vue/composition-api";
import { InputReviewCreate, ReviewSubjectType } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import ReviewInput from "./ReviewInput.vue";

const REVIEW_RATING_PLACEHOLDER = 0;

export default defineComponent({
  name: "ReviewsSendController",
  components: { ReviewInput },
  props: {
    postId: { type: String, required: true },
    allowReview: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const comment = ref<string>("");
    const sending = ref(false);
    const removing = ref(false);

    const allowSend = computed(() => !!comment.value.trim());

    const sendReview = useAuthorisedOnly(async () => {
      if (!allowSend.value || sending.value) return;
      try {
        sending.value = true;
        const newReview: InputReviewCreate = {
          subject: {
            subjectId: props.postId,
            subjectType: ReviewSubjectType.POST,
          },
          rating: REVIEW_RATING_PLACEHOLDER,
          comment: comment.value,
        };
        const review = await providers.ReviewProvider.create({ data: newReview });
        comment.value = "";
        emit("sent", review);
      } finally {
        sending.value = false;
      }
    });

    const removeReview = useAuthorisedOnly(async (id: string, cb: () => void) => {
      try {
        removing.value = true;
        await providers.ReviewProvider.delete({ reviewId: id });
        emit("remove", id);
        cb();
      } finally {
        removing.value = false;
      }
    });

    const setComment = (username: string) => {
      comment.value = comment.value.replace(/^@[a-z0-9_.-]+/gi, "");
      comment.value = comment.value.replace(/^, /gi, "");
      comment.value = `${username}, ${comment.value}`;
    };

    return {
      comment,
      removeReview,
      removing,
      sending,
      allowSend,
      sendReview,
      setComment,
    };
  },
});
